import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ApplicationRouter as Router, Route, RouterOutlet, } from "@aviv-unified-frontend/runtime/router";
import { CLIENT_ROUTES } from "../../constants";
import { TemplateWrapper } from "@/templates/TemplateWrapper";
import { RouteContainer } from "../RouteContainer/RouteContainer";
import { getRouteUrls } from "@/app/router/utils/getRouteUrls";
import { MapContainer } from "@/domains/map";
export const ApplicationRouter = () => {
    const routeUrls = getRouteUrls();
    return (_jsx(Router, { children: routeUrls.map((pattern) => (_jsxs(Route, { path: `${pattern}`, element: _jsx(RouterOutlet, {}), children: [_jsx(Route, { path: "", element: _jsx(TemplateWrapper, {}) }), _jsx(Route, { path: `${CLIENT_ROUTES.MAP}`, element: _jsx(RouteContainer, { children: _jsx(MapContainer, {}) }) })] }, `${pattern}-base`))) }));
};
